import React from 'react';
import Div from '../../common/components/div';
import translate from '../../common/functions/translate';
import { usePageViewWithSteps } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/use.page.title';
import use from '../../common/objects/use';
import UpdatePasswordAndSecretQuestion from './update.password.and.secret.question';
import YourBasicInformation from './your.basic.information';
import YourMedicareInformation from './your.medicare.information';

export default function UnlockAccount() {
    usePageTitle(translate('Unlock account'));

    const data = use.unlockAccountData;
    const stepTitle = {
        1: 'Your Medicare information',
        2: 'Your basic information',
        3: 'Update password & secret question',
    };
   
    const getStep = () => {
        switch (data.step.get()) {
                case 1:
                    return <YourMedicareInformation/>;
                case 2:
                    return <YourBasicInformation/>;
                case 3:
                    return <UpdatePasswordAndSecretQuestion/>;
                default:
                    return <YourMedicareInformation/>;
        }
    };
   
    usePageViewWithSteps('Unlock account', data.step.get(), stepTitle[data.step.get()]);
   
    return <>
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}
        >
            {getStep()}
        </Div>
    </>;
}